interface CurrentUserRoleFlags {
  isSuperAdminRole?: boolean;
}

/**
 * No.153: only super_admin may edit clinic name / name (kana) — the backend
 * rejects the change with a 422 for any other role (see
 * UpdateClinicRequest::withValidator in sheepmedical-api).
 */
export function canEditClinicName(
  currentUser: CurrentUserRoleFlags | null | undefined,
): boolean {
  return !!currentUser?.isSuperAdminRole;
}
